import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'Patrizia Conti',
  role: 'Docente di Economia Aziendale, ITE',
  city: 'Milano',
  text: 'Con il Volume 2 ho finalmente trovato esercizi graduati che funzionano davvero. Le verifiche sono pronte in 5 minuti e i ragazzi capiscono al primo colpo.'
}, {
  name: 'Giuseppe Marini',
  role: 'Docente ITE Quinquennale',
  city: 'Bologna',
  text: 'Il Bonus Excel vale da solo molto più dei €19,90. Inserisco i dati e in 30 secondi ho la valutazione pronta. Ho recuperato ogni domenica sera.'
}, {
  name: 'Antonella Greco',
  role: 'Docente di Economia Aziendale, IIS Tecnico',
  city: 'Napoli',
  text: 'Le UDA sono perfettamente allineate al MIM e il Dirigente le ha approvate al primo invio. Un investimento che rifarei domani mattina.'
}, {
  name: 'Roberto Vitale',
  role: 'Docente ITE Triennio',
  city: 'Torino',
  text: 'Il Volume 6 sulla Seconda Prova è eccezionale. I miei studenti arrivano alla Maturità preparati e io entro in Commissione finalmente sereno.'
}, {
  name: 'Sabrina Russo',
  role: 'Docente di Economia Aziendale, ITE',
  city: 'Roma',
  text: 'Avere studenti DSA in una classe di contabilità era la mia ansia più grande. Ora differenzio senza moltiplicare il lavoro.'
}];
export function Testimonials() {
  return <section className="py-10 sm:py-14 px-4" data-id="element-248">
      <div className="max-w-6xl mx-auto" data-id="element-249">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-8 uppercase text-brand-cream" data-id="element-250">
          Cosa dicono i colleghi
        </motion.h2>

        <div className="grid grid-cols-1 gap-4" data-id="element-251">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-card border border-white/5 p-6 rounded-2xl flex flex-col" data-id="element-252">
              <div className="flex text-brand-gold mb-4" data-id="element-253">
                {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-current" data-id="element-254" />)}
              </div>
              <p className="text-gray-300 font-medium italic mb-6 flex-grow" data-id="element-255">
                "{t.text}"
              </p>
              <div className="border-t border-white/10 pt-4 mt-auto" data-id="element-256">
                <div className="font-bold text-brand-cream" data-id="element-257">{t.name}</div>
                <div className="text-sm text-brand-orange" data-id="element-258">{t.role}</div>
                <div className="text-xs text-gray-500 mt-1" data-id="element-259">{t.city}</div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}